export default __webpack_public_path__ + "static/media/logo-2.0341d391.png";